var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessonFailedIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.047 0H13.344v112h85.312V21.61L77.046 0zm1.922 11.203l8.484 8.485H78.97v-8.485zm-59.063 94.235V6.562h52.5V26.25h19.688v79.188H19.906z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.953 58.718l4.64-4.64-4.64-4.64 4.64-4.64-4.64-4.641-4.64 4.64-4.64-4.64-4.64 4.64 4.64 4.64-4.64 4.64 4.64 4.641 4.64-4.64 4.64 4.64zM80.328 40.157l-4.64 4.64-4.64-4.64-4.64 4.64 4.64 4.64-4.64 4.64 4.64 4.641 4.64-4.64 4.64 4.64 4.64-4.64-4.64-4.64 4.64-4.64-4.64-4.641zM56 65.844c-12.665 0-22.969 10.303-22.969 22.969v3.28h6.563v-3.28c0-9.047 7.36-16.407 16.406-16.407s16.406 7.36 16.406 16.406v3.282h6.563v-3.281c0-12.666-10.304-22.97-22.969-22.97z",
    fill: "#fff"
  })));
}
export default SvgLessonFailedIc;